import moment from "moment";
import { ITheme } from "../interface";

import SkillAndTools from "./skillAndTools";

import LogoLinkedIn from "../assets/images/icons/linkedin.svg";
import LogoGithub from "../assets/images/icons/github.svg";
import LogoDev from "../assets/images/icons/dev.svg";
import LogoMedium from "../assets/images/icons/medium.svg";

import LogoBintango from "../assets/images/company/bintango.jpeg";
import LogoEkuid from "../assets/images/company/ekuid.jpeg";
import LogoHaloJasa from "../assets/images/company/halojasa.jpeg";

export const themes: Record<"dark" | "light", ITheme> = {
  dark: {
    name: "dark", // https://colorhunt.co/palette/040d12183d3d5c837493b1a6
    colors: {
      font: "white",
      hightlightFont: "#71C9CE",
      cssFilterHighliightFont:
        "invert(80%) sepia(18%) saturate(857%) hue-rotate(134deg) brightness(92%) contrast(84%)",
      primary: "#040D12",
      cssFilterPrimary:
        "invert(5%) sepia(13%) saturate(1964%) hue-rotate(156deg) brightness(89%) contrast(101%)",
      secondary: "#183D3D",
      tertiary: "#5C8374",
      quarternary: "#93B1A6",
    },
  },
  light: {
    name: "light", // https://colorhunt.co/palette/e3fdfdcbf1f5a6e3e971c9ce
    colors: {
      font: "black",
      hightlightFont: "#008DDA",
      cssFilterHighliightFont:
        "invert(39%) sepia(57%) saturate(3358%) hue-rotate(178deg) brightness(95%) contrast(101%)",
      primary: "#E3FDFD",
      cssFilterPrimary:
        "invert(95%) sepia(38%) saturate(190%) hue-rotate(94deg) brightness(104%) contrast(98%)",
      secondary: "#CBF1F5",
      tertiary: "#A6E3E9",
      quarternary: "#71C9CE",
    },
  },
};

export const logoFindMeAt = [
  {
    name: "LinkedIn",
    logo: LogoLinkedIn,
    link: "https://www.linkedin.com/in/rizki-iqbal",
  },
  {
    name: "Github",
    logo: LogoGithub,
    link: "https://github.com/Rizky-Iqbal36",
  },
  { name: "Dev", logo: LogoDev, link: "https://dev.to/rizkiiqbal36" },
  {
    name: "Medium",
    logo: LogoMedium,
    link: "https://medium.com/@rizkiiqbal36",
  },
];

const yearsExperience = Math.round(
  moment().diff("2021-01-01", "days") / 365.2422
);
export const aboutMe = {
  long: `As someone who loves crafting something from nothing, I find a thrill and excitement in software engineering. As I continue to learn and become more proficient, I am amazed by what I am capable of, unlocking my true potential. With approximately ${yearsExperience} years of experience, I possess a relentless desire to continuously expand my knowledge and skills. Passionate about startups and technologies, I am driven by the opportunity to innovate and contribute to transformative projects. My ultimate goal is to leverage my expertise to deliver advanced solutions, making a meaningful and lasting impact on the projects I work on.`,
  short: `A passionate software engineer with around ${yearsExperience} years of experience, I'm driven to continually grow my skills. With a keen interest in startups and technologies, I aim to innovate and deliver impactful solutions, making a lasting difference in my projects.`,
};

export const mediaMaxWidthValue = {
  smallPhoneV1: 320,
  smallPhoneV2: 480,
  smallPhoneV3: 540,
  mediumPhoneV1: 640,
  mediumPhoneV2: 720,
  mediumPhoneV3: 750,
  mediumPhoneV4: 768,
  mediumTablet: 992,
  smallDesktopV1: 1170,
  meidumDesktopV1: 1200,
  meidumDesktopV2: 1366,
};
export const screenSize = (() => {
  let values: Record<keyof typeof mediaMaxWidthValue, string> = {} as any;
  for (const key of Object.keys(
    mediaMaxWidthValue
  ) as (keyof typeof mediaMaxWidthValue)[]) {
    values[key] = mediaMaxWidthValue[key] + "px";
  }
  return { maxWidth: values };
})();

export const workExperience = [
  {
    companyName: "BintanGO",
    companyLogo: LogoBintango,
    title: "FullStack Engineer",
    location: "Jakarta, Indonesia (Hybrid)",
    description: `
- Integrate server-side application with 3rd party APIs 
- Deploying, improving, maintaining microservice architecture
  - Create maintainable, testableand scalable server architecture using nestjs
  - Introducing event driven communication on the existing microservice using google pubsub
  - Implementing CI using github action
- Implementing Worker thread to enable pararellism and enhance overall processing speed
- Transitioning some APIs from Lumen to Node.js for optimization and enhanced functionality.
    `,
    links: {
      company: "https://www.bintango.com",
      linkedin: "https://www.linkedin.com/company/bintango",
    },
    workType: "Fulltime",
    startDate: "2022-05",
    endDate: "2024-03",
    techStack: [SkillAndTools[1], SkillAndTools[2], SkillAndTools[5]],
  },
  {
    companyName: "Ekuid",
    companyLogo: LogoEkuid,
    title: "FullStack Engineer",
    location: "Jakarta, Indonesia (Remote)",
    description: `
- Helping on building system architecture to create secure, high-performant, testable, scalable and maintainable server-side application using graphql that run on top of fastify:
  - Implementing TDD culture on the app
  - Design pattern implementation using repository pattern
  - Setup app containerization with docker
  - Best practice to handle graphql middleware
  - Implement end-to-end encryption
- Integrate server-side application with 3rd party APIs
- Deploying, maintaining and managing client & server side application with GKE
- CI/CD implementation using google cloud
    `,
    links: {
      company: "https://www.eku.id",
      linkedin: "https://www.linkedin.com/company/ekuid",
    },
    workType: "Fulltime",
    startDate: "2021-10",
    endDate: "2022-04",
    techStack: [SkillAndTools[1], SkillAndTools[16]],
  },
  {
    companyName: "HaloJasa",
    companyLogo: LogoHaloJasa,
    title: "Jr. Software Engineer",
    location: "Jakarta, Indonesia",
    description: `
- Engineered modern application using typescript, javascript, sql and nosql
- Built well communicated microservice with google pub/sub
- Hands-on gitlab CI/CD
- Develop chat feature both in backend and frontend using FCM
- Create API specification using stoplight
    `,
    links: {
      company: "https://www.halojasa.com",
      linkedin: "https://www.linkedin.com/company/halojasa",
    },
    workType: "Fulltime",
    startDate: "2021-01",
    endDate: "2021-10",
    techStack: [SkillAndTools[1], SkillAndTools[2], SkillAndTools[18]],
  },
];

export const BlogsData = [
  {
    title: "Typescrypt: Make your life easier with decorators",
    thumbnail:
      "https://miro.medium.com/v2/resize:fit:1500/format:webp/1*mqU93d8Elde6c8uCCluKEA.png",
    link: "https://dev.to/rizkiiqbal36/typescrypt-make-your-life-easier-with-decorators-3ppp",
  },
  {
    title: "Get Rid of Migration Files",
    thumbnail:
      "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*pjNWRSIxRcgHSxX5S6XD5g.png",
    link: "https://dev.to/rizkiiqbal36/get-rid-of-migration-files-3bhb",
  }
];
